import React from 'react';
import OrdersList from '../controls/OrdersList.jsx';
import OrdersSearch from "../controls/OrdersSearch.jsx";

import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Format from '../../utils/Formatter';

import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';


class BuscaPedido extends React.Component {

    render() {
        return (
            <OrdersSearch
                orders={this.props.pedidos.pagos}
                onSelectOrder={(orderId) => this.props.events.onSelectPaidOrder(orderId, this.props.token)}
                selectedOrder={this.props.pedidos.selecionada}
                idClienteName="idClientePedidos"
                idClientePedidos={this.props.pedidos.idClientePedidos}
                cpfClienteName="cpfClientePedidos"
                cpfClientePedidos={this.props.pedidos.cpfClientePedidos}
                showQrPreviewName="showQrPreviewPedidos"
                showQrPreviewPedidos={this.props.pedidos.showQrPreviewPedidos}
                onUpdateValue={this.props.events.onUpdateText}
                onShowDialog={this.props.events.onShowDialog}
                onRefresh={() => this.props.events.onListPaidOrders(this.props.token)}
            />
        );
    }
}

class Pedido extends React.Component {

    componentDidUpdate() {
        if (this.props.pedidos.selecionada) {
            $('#printButton').focus();
        }
    }

    render() {
        const selectedOrder = this.props.pedidos.selecionada;

        const onCloseSuccess = () => {
            this.props.events.onListPaidOrders(this.props.token);
            this.props.events.onCloseSwal();
        };

        const onDeleteOrder = () => {
            let promise = this.props.events.onShowSwal("Aguarde", "Seu pedido está sendo processado.");
            promise = promise.then(() => this.props.events.onDeleteCart(selectedOrder.id, this.props.token));
            promise.catch(() => this.props.events.onShowSwal("Erro!", "Ocorreu um erro. Por favor, tente novamente.", this.props.events.onCloseSwal));
            promise.then(() => this.props.events.onShowSwal("Sucesso!", "O pedido foi estornado.", onCloseSuccess));
        };

        const onClickRemove = (cartId) => {
            this.props.events.onShowSwal("Confirmar ação", "O pedido será estornado.", onDeleteOrder, this.props.events.onCloseSwal);
        };

        const footer = (
            <div className="btn-toolbar">
                <button type="button" id="printButton" className="btn btn-primary m-b-5"
                    onClick={() => this.props.events.onPrintOrder(selectedOrder.id, this.props.token, 'receipt')}>
                    <span className="glyphicon glyphicon-print" /> Comprovante Pagamento
                </button>
                <button type="button" className="btn btn-primary m-b-5"
                    onClick={() => this.props.events.onPrintOrder(selectedOrder.id, this.props.token, 'delivery')}>
                    <span className="glyphicon glyphicon-print" /> Comprovante Expedição
                </button>
                <button type="button" className="btn btn-danger" onClick={onClickRemove }>
                    <span className="glyphicon glyphicon-remove" /> Estornar
                </button>
            </div>
        );
        const clientNameAppendix = selectedOrder ? " - " + selectedOrder.nome : "";

        return (
            <div className="panel panel-color panel-primary js-panel-resp">
                <div className="panel-heading">
                    <h3 className="panel-title">{"Pedido do cliente" + clientNameAppendix}</h3>
                </div>
                <div className="panel-body js-panel-body-w-footer">
                    <BuscaPedido {...this.props} />
                    {selectedOrder &&
                        <div className="form-group">
                            <label>Itens do pedido</label>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Valor</th>
                                            <th>Qtd</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedOrder.items.map(i => (
                                          <tr key={i.id_produto}>
                                              <td>{i.descricao}</td>
                                              <td>{Format.money(i.preco)}</td>
                                              <td>{i.quantidade}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
                {selectedOrder &&
                  <div className="panel-footer">
                      {footer}
                  </div>
                }
            </div>
        );
    }
}

class PedidosPagos extends React.Component {

    render() {
        return (
            <OrdersList
                title={"Pedidos pagos"}
                onRefresh={() => this.props.events.onListPaidOrders(this.props.token)}
                orders={this.props.pedidos.pagos}
                cpf={this.props.pedidos.cpfClientePedidos}
                selectedOrder={this.props.pedidos.selecionada}
                onSelectOrder={(orderId) => this.props.events.onSelectPaidOrder(orderId, this.props.token)}
                noOrderText={"Nenhuma ordem paga"}
                badgeType={"bg-info"}
                badgeGlyph={"glyphicon glyphicon-print"}
                onClickBadge={(cartId) => this.props.events.onPrintOrder(cartId, this.props.token)}
            />
        );
    }
}

class LojaPedidos extends React.Component {

    render() {
        const app = this.props.app;
        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PEDIDOS_PAGOS)
            return null;

        return (
            <div className="wraper container-fluid">
                <div className="row">
                    <div className="row">
                        <div className="col-lg-7">
                            <Pedido {...this.props} />
                        </div>
                        <div className="col-lg-5">
                            <PedidosPagos {...this.props} />
                        </div>
                    </div>
                </div>
                <SweetAlert
                    show={this.props.caixa.confirm}
                    title={this.props.caixa.title}
                    text={this.props.caixa.text}
                    showConfirmButton={!!this.props.caixa.onConfirm}
                    onConfirm={this.props.caixa.onConfirm}
                    showCancelButton={!!this.props.caixa.onCancel}
                    onCancel={this.props.caixa.onCancel}
                    cancelButtonText="Cancelar"
                />
            </div>
        );
    }
}

export default LojaPedidos;



// WEBPACK FOOTER //
// src/views/pages/LojaPedidos.jsx